var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "#888888",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C12 9.31356 9.31356 12 6 12C2.68644 12 0 9.31356 0 6C0 2.68644 2.68644 0 6 0C9.31356 0 12 2.68644 12 6ZM6 4.70064C6.35484 4.70064 6.64266 4.98845 6.64266 5.34377V8.75585C6.64266 9.11116 6.35485 9.39898 6 9.39898C5.64515 9.39898 5.35734 9.11117 5.35734 8.75585V5.34377C5.35734 4.98846 5.64515 4.70064 6 4.70064ZM6.64266 3.4284C6.64266 3.07356 6.35485 2.78574 6 2.78574C5.64515 2.78574 5.35734 3.07355 5.35734 3.4284V3.44012C5.35734 3.79496 5.64515 4.08278 6 4.08278C6.35485 4.08278 6.64266 3.79497 6.64266 3.44012V3.4284Z",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipBg);
export default __webpack_public_path__ + "static/media/tooltip-bg.9cbae34f02d8fc6e18a4f7424a647d41.svg";
export { ForwardRef as ReactComponent };